import { InputFormFieldInit } from "./base";
import { FormFieldInputNumber } from "./number";

export class FormFieldInputPercentage extends FormFieldInputNumber {
  constructor(init: InputFormFieldInit<FormFieldInputPercentage>) {
    init.min = init.min ?? 0;
    init.max = init.max ?? 100;
    init.inputSuffix = "%";
    super(init);
  }
}
